import { GanttConfig, ProjectModelConfig } from '@bryntum/gantt';

export const ganttConfig: Partial<GanttConfig> = {
    columns: [
        { type: 'name', field: 'name', width: 300 },
        {
            type: 'startdate',
            field: 'startDate',
            width: 120,
            text: 'Current Start',
        },
        {
            type: 'enddate',
            field: 'endDate',
            width: 120,
            text: 'Current Finish',
        },
        {
            type: 'baselinestartdate',
            field: 'baselineStartDate',
            width: 120,
            text: 'Baseline Start',
        },
        {
            type: 'baselineenddate',
            field: 'baselineEndDate',
            width: 120,
            text: 'Baseline Finish',
        },
        { field: 'duration', type: 'duration', width: 120, text: 'Duration' },
        { field: 'pComp', type: 'percentdone', width: 120, text: 'Submitted Complete' },
    ],
    subGridConfigs: {
        locked: {
            width: 540,
        },
    },
    viewPreset: 'year',
    barMargin: 10,
    destroyStore: true,
    displaySchedulingIssueResolutionPopup: false,
    // Prevents the timespan from changing when zooming in and out, keeping the original timespan visible.
    zoomKeepsOriginalTimespan: true,
};

export const ganttConfigSharedResourses: Partial<GanttConfig> = {
    columns: [
        { type: 'name', field: 'name', width: 500 },
        {
            type: 'startdate',
            field: 'startDate',
            width: 120,
            text: 'Start Date',
        },
        {
            type: 'enddate',
            field: 'endDate',
            width: 120,
            text: 'End Date',
        },
        { field: 'activityResourses', width: 240, text: 'Resources (Units)' },
    ],
    viewPreset: 'year',
    barMargin: 10,
    destroyStore: true,
    // Prevents the timespan from changing when zooming in and out, keeping the original timespan visible.
    zoomKeepsOriginalTimespan: true,
    displaySchedulingIssueResolutionPopup: false,
};

export const projectConfig: Partial<ProjectModelConfig> = {
    taskStore: {
        autoTree: true,
        transformFlatData: true,
    },
};
